module.exports = __webpack_public_path__ + "img/snow.c50c627b.svg";